import React from 'react';
import axios from "axios";
import {
  Highlight
} from 'react-instantsearch';
import PropTypes from 'prop-types';

export default function TeaserProduct(props) {
  const { hit } = props;
  const isWebshopPage =
    typeof window !== 'undefined' &&
    window.location.pathname.indexOf('webwinkel') !== -1;
  const hasImage =
    'styled_image_url' in hit && hit.styled_image_url;
  const bundleLabel = hit.entity_bundle_processed || '';
  const placeholderInitial =
    bundleLabel && bundleLabel.charAt(0) ? bundleLabel.charAt(0) : 'P';

  const handleAddToCartClick = (variation_id) => {
    axios({
      method: "POST",
      url: Drupal.url('cart/add?_format=json'),
      data: JSON.stringify([{
        purchased_entity_type: 'commerce_product_variation',
        purchased_entity_id: variation_id,
        quantity: 1
      }]),
      headers: {
        'Content-Type': 'application/json',
      }
    })
      .then(() => {
        Drupal.cartFlyout.fetchCarts();
        Drupal.cartFlyout.flyoutOffcanvasToggle();
      })
      .catch(() => undefined);
  };

  const renderProductTeaser = () => (
    <article>
      <div className="product-teaser">
        <div className="product-images-content">
          <div className="product-images">
            <a href={hit.entity_alias}>
              <div className="product-image">
                <img src={hit.styled_image_url} alt={hit.variation_title_processed} height="150" />
              </div>
            </a>
          </div>

          <div className="product-content">
            <div className="field field--name-title field--type-string field--label-hidden field__item">
              <a href={hit.entity_alias}>
                <Highlight attribute="variation_title_processed" hit={hit}/>
              </a>
            </div>

            {'field_isbn' in hit ? (
              <div className="field field--name-field-isbn field--type-string field--label-hidden field__item">
                {"ISBN: " + hit.field_isbn}
              </div>
            ) : null}

            <div className="field field--name-body field--type-text-with-summary field--label-hidden field__item">
              <div dangerouslySetInnerHTML={{__html: hit.product_body}}></div>
            </div>

            <div className="product-availability">
              {hit.variation_availability_processed}
            </div>
          </div>
        </div>

        <div className="product-price-cart">
          <div className="product-price">
            <div className="field--name-price">
              € {hit.variation_price_processed}
            </div>
          </div>

          <div className="field field--name-variations field--type-entity-reference field--label-hidden field__items">
            <div className="field__item">
              <div data-view-mode="teaser" data-langcode="nl">
                <div className="variations-common-elements">
                  <div className="js-form-item form-item js-form-item-quantity quantity">
                    <input readOnly type="number" name="quantity" min="1" value="1" />
                  </div>
                  <div className="form-actions form-group js-form-wrapper form-wrapper">
                    <input className="button button--primary js-form-submit form-submit" type="submit"
                           onClick={() => handleAddToCartClick(hit.variation_id_processed)}
                           value="Aan winkelwagen toevoegen"/>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

      </div>
    </article>
  );

  const renderSearchCard = () => (
    <a className="search-card search-card--product search-card--product-has-aside" href={hit.entity_alias}>
      <div className="search-card__media">
        {hasImage ? (
          <img
            src={hit.styled_image_url}
            alt={hit.variation_title_processed}
            loading="lazy"
          />
        ) : (
          <div className="search-card__media-placeholder" aria-hidden="true">
            <span>{placeholderInitial}</span>
          </div>
        )}
      </div>

      <div className="search-card__content">
        <span className="search-card__badge">
          {bundleLabel}
        </span>

        <h3 className="search-card__title">
          <Highlight attribute="variation_title_processed" hit={hit} />
        </h3>

        {'field_isbn' in hit && hit.field_isbn ? (
          <div className="search-card__meta">
            ISBN: {hit.field_isbn}
          </div>
        ) : null}

        <span className="search-card__cta">
          Meer informatie
        </span>
      </div>

      <div className="search-card__aside search-card__aside--product">
        {hit.variation_price_processed ? (
          <div className="search-card__price">
            € {hit.variation_price_processed}
          </div>
        ) : null}

        <div className="search-card__actions">
          <div className="variations-common-elements">
            <div className="js-form-item form-item js-form-item-quantity quantity">
              <input readOnly type="number" name="quantity" min="1" value="1" />
            </div>
            <div className="form-actions form-group js-form-wrapper form-wrapper">
              <input
                className="button button--primary js-form-submit form-submit"
                type="submit"
                aria-label="Aan winkelwagen toevoegen"
                value="Aan winkelwagen toevoegen"
                onClick={(event) => {
                  event.preventDefault();
                  event.stopPropagation();
                  handleAddToCartClick(hit.variation_id_processed);
                }}
              />
            </div>
          </div>
        </div>
      </div>
    </a>
  );

  if (isWebshopPage) {
    return (
      <div className="views-row">
        {renderProductTeaser()}
      </div>
    );
  }

  return renderSearchCard();
}

TeaserProduct.propTypes = {
  hit: PropTypes.object.isRequired,
};
